import Modal from "../../../../../shared/components/UI/Modal/Modal"
import { Dispatch, SetStateAction, useState } from "react"
import Image from "../../../../../shared/components/other/Image/Image"
import { Request } from "./RequestCard"
import useManageRequest from "../hooks/useManageRequest"
import useDeleteRequest from "../hooks/useDeleteRequest"
import { dialogNotify } from "../../../../../shared/services/Notifications/NotificationServices"

interface RegInfoModalProps {
    isOpen: boolean
    setIsOpen: Dispatch<SetStateAction<boolean>>
    eventSlug?: string
    requestData: Request
    is_approved: boolean | undefined
    canDelete?: boolean
}

export default function RegInfoModal({
    isOpen,
    setIsOpen,
    eventSlug,
    requestData,
    is_approved,
    canDelete = true,
}: RegInfoModalProps) {
    const { mutate: manageMutate } = useManageRequest(eventSlug)
    const { mutate: deleteMutate } = useDeleteRequest(eventSlug)

    const [isMobile] = useState(window.innerWidth <= 768)

    const mainAvatar = requestData.team?.avatar_link ?
        <Image
            resolution="avatar"
            src={requestData.team?.avatar_link}
            sizes='62px'
        />
        : <img src='/no_photo.svg' />

    const toManage = (status: string) => {

        requestData.users?.map(item => item.username).forEach(item =>
            manageMutate({
                status,
                username: item
            })
        )
    }

    const confirmManage = (status: 'approved' | 'rejected') => {
        if (status === 'approved') {
            toManage(status)
            return
        }

        dialogNotify({
            status: 'info',
            title: 'Отклонение регистрации',
            description: 'Вы уверены, что хотите отклонить заявку?',
            acceptText: 'Отклонить',
            rejectText: 'Отмена',
            acceptHandler: () => {
                toManage(status)
                setIsOpen(false)
            }
        })
    }

    const confirmDelete = () => {
        dialogNotify({
            status: 'info',
            title: 'Удаление регистрации',
            description: 'Вы уверены, что хотите удалить регистрацию?',
            acceptText: 'Удалить',
            rejectText: 'Отмена',
            acceptHandler: () => {
                requestData?.users?.map(item => item.username).forEach(user =>
                    deleteMutate(user)
                )
                setIsOpen(false)
            }
        })
    }

    const buttons = is_approved
        ? (
            <div className="regInfoModal__buttons">
                {canDelete && (
                    <button className="delete" onClick={confirmDelete}>
                        Удалить регистрацию
                    </button>
                )}
            </div>
        )
        : (
            <div className="regInfoModal__buttons">
                <button onClick={() => confirmManage('rejected')}>
                    Отклонить
                </button>
                <button className="accept" onClick={() => confirmManage('approved')}>
                    Принять
                </button>
            </div>
        )

    return (
        <Modal isOpen={isOpen} closeModal={() => setIsOpen(false)} className="regInfoModal">
            <h1>Командная заявка</h1>
            <div className="regInfoModal__header">
                {!isMobile && <div className="eventManagementModal__requestCard-regType">
                    <svg width="19" height="13" viewBox="0 0 19 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.41861 9.10589C5.40762 8.98181 5.40657 8.85947 5.40657 8.7343C5.40657 8.60241 5.42606 8.47241 5.4651 8.34876C5.4651 8.34876 6.0899 7.42421 6.38538 6.33794C6.06178 5.58333 5.76803 4.64422 5.76803 3.7133C5.76803 3.49707 5.78238 3.28782 5.80247 3.08169C5.38079 2.59343 4.81106 2.31693 4.18167 2.31693C2.88216 2.31693 1.82767 3.48879 1.82767 5.30999C1.82767 6.7672 2.90056 8.34871 2.90056 8.34871C2.93841 8.47237 2.95795 8.60237 2.95795 8.73426V9.01137C2.95795 9.35698 2.77549 9.67151 2.49092 9.81546L0.787507 10.5846C0.391606 10.7863 0.109901 11.1883 0.0313229 11.6614L0.00205817 12.0755C-0.0128496 12.2911 0.0536846 12.5035 0.18679 12.6614C0.319307 12.8206 0.505801 12.91 0.701438 12.91H3.48574C3.582 11.5428 3.51536 10.048 4.96536 9.31007L5.41861 9.10589Z" fill="#F7F8F8" />
                        <path d="M18.7687 11.6614C18.6907 11.1883 18.409 10.7863 18.0131 10.5846L16.3086 9.81546C16.024 9.67151 15.8427 9.35698 15.8427 9.01137V8.73426C15.8427 8.60237 15.8616 8.47237 15.9006 8.34871C15.9006 8.34871 16.9729 6.7672 16.9729 5.30999C16.9729 3.48879 15.919 2.31693 14.6172 2.31693C13.989 2.31693 13.4192 2.59343 12.9964 3.08295C13.0171 3.28843 13.0314 3.49703 13.0314 3.71326C13.0314 4.64353 12.7382 5.58268 12.4152 6.33725C12.7101 7.42352 13.336 8.34871 13.336 8.34871C13.3739 8.47237 13.394 8.60237 13.394 8.73426C13.394 8.85957 13.3923 8.98174 13.3813 9.10585L13.8036 9.29611C15.2799 10.0424 15.2163 11.52 15.3137 12.91H18.0991C18.2948 12.91 18.4812 12.8206 18.6132 12.6614C18.7463 12.5035 18.8129 12.2911 18.7979 12.0755L18.7687 11.6614Z" fill="#F7F8F8" />
                        <path d="M13.5076 10.097L11.4456 9.16547C11.1014 8.99043 10.8817 8.60995 10.8817 8.19271V7.85664C10.8817 7.69811 10.9046 7.5402 10.9523 7.38992C10.9523 7.38992 12.2489 5.4774 12.2489 3.71326C12.2489 1.50903 10.9735 0.0917969 9.39976 0.0917969C7.82658 0.0917969 6.55061 1.50907 6.55061 3.71326C6.55061 5.4774 7.84839 7.38992 7.84839 7.38992C7.89488 7.5402 7.91897 7.69811 7.91897 7.85664V8.19271C7.91897 8.60995 7.69752 8.99043 7.35383 9.16547L5.29186 10.097C4.81279 10.3398 4.47142 10.8268 4.37734 11.4001L4.27119 12.9099H14.5283L14.4233 11.4001C14.3281 10.8269 13.9867 10.3399 13.5076 10.097Z" fill="#F7F8F8" />
                    </svg>
                </div>}
                <div className="regInfoModal__header-container">
                    <div className="eventManagementModal__requestCard-applicantInfo">
                        {mainAvatar}
                        <a onClick={() => window.open(`/team/${requestData?.team?.slug}`)}>{requestData?.team?.name}</a>
                    </div>
                    <div className="regInfoModal__header-regInfo">
                        <p>{'Желаемая сторона: ' + requestData?.desired_event_party}</p>
                    </div>
                </div>
            </div>
            <div className="regInfoModal__infoItem">
                <h1>Название</h1>
                <p>{requestData?.team?.name}</p>
            </div>
            <div className="regInfoModal__infoItem">
                <h1>Количество человек</h1>
                <p>{requestData?.users?.length}</p>
            </div>
            <div className="regInfoModal__infoItem">
                <h1>Участники</h1>
                <div className="regInfoModal__infoItem-teamMembersList">
                    {requestData?.users?.map((item) => (
                        <div key={item.username} className="regInfoModal__infoItem-teamMembersList_item">
                            {item.avatar
                                ? <Image resolution="avatar" src={item.avatar} />
                                : <img src='/no_photo.svg' />
                            }
                            <p>{item.callsign}</p>
                        </div>
                    ))}
                </div>
            </div>
            {buttons}
        </Modal>
    )
}
